import { API, root } from "./config.js";
import { getData } from "./data.js";
import { addLoader, removeLoader, setLocation } from "./healpers.js";
import { header } from "./views/header.js";
import { initWeaponPage} from "./weaponPageFunctions.js";

export const loadWeaponPage = (id) => {
    root.innerHTML = ''
    addLoader(root)
    getData(`${API}armament/${id}`).then(data => {
        setTimeout(() => {
            removeLoader()
            setLocation(id, data.name)
            header()
            initWeaponPage(id, data.name)
        }, 200);
    })
}